import { render } from "./UserRecharge.vue?vue&type=template&id=188d102a&scoped=true"
import script from "./UserRecharge.vue?vue&type=script&lang=js"
export * from "./UserRecharge.vue?vue&type=script&lang=js"

import "./UserRecharge.vue?vue&type=style&index=0&id=188d102a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188d102a"]])

export default __exports__